import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/logo/logo.svg";
import Menu from "./Menus";
import { MdArrowForwardIos } from "react-icons/md";

const Sidebar = () => {
  const location = useLocation(); // current path
  const [OpenIndex, setOpenIndex] = useState(Menu.map((_, i) => i));

  const toggleSubMenu = (index) => {
    if (OpenIndex.includes(index)) {
      setOpenIndex(OpenIndex.filter((i) => i !== index));
    } else {
      setOpenIndex([...OpenIndex, index]);
    }
  };

  return (
    <div className="w-[300px] h-screen flex flex-col border-r">
      <div className="flex justify-center items-center py-2 h-[60px] bg-white sticky top-0 z-10">
        <img className="w-[170px]" src={Logo} alt="Dhoorbin.com" />
      </div>

      <div className="flex-1 overflow-y-auto px-3 scrollbar-hide pt-3">
        {Menu.map((item, index) => {
          const isActive = item.path && location.pathname === item.path;

          return (
            <div key={index} className="mb-3">
              <Link to={`${item.path ? item.path : "#"}`}>
                <div
                  onClick={() => toggleSubMenu(index)}
                  className={`flex justify-between items-center border py-2 px-2 rounded-lg select-none cursor-pointer ${
                    isActive ? "bg-blue-100" : "bg-white"
                  }`}
                >
                  <div className="flex items-center justify-start gap-x-2 text-black/80">
                    <div>{item.icon}</div>
                    <div>
                      <p>{item.name}</p>
                    </div>
                  </div>
                  <div>
                    {item.children && (
                      <div className="text-black/80">
                        <MdArrowForwardIos
                          className={
                            OpenIndex.includes(index)
                              ? "rotate-90 transform transition-all"
                              : ""
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Link>

              {OpenIndex.includes(index) && item.children && (
                <div>
                  {item.children.map((child, childIndex) => {
                    const isChildActive =
                      child.path && location.pathname === child.path;

                    return (
                      <div
                        key={childIndex}
                        className={`relative py-2 pl-10 pr-4 mt-1 select-none cursor-pointer ${
                          isChildActive ? "bg-blue-100 rounded-lg" : ""
                        }`}
                      >
                        <Link to={child.path}>
                          <div className="flex items-center justify-start gap-x-2 text-black/80">
                            <div>
                              <p className="text-sm">{child.name}</p>
                            </div>
                            <div className="h-10 absolute top-0 left-5 border-gray-100 border-r border"></div>
                            <div className="rotate-90 h-4 absolute top-0 transform translate-y-1/2 left-7 border-gray-100 border-r border"></div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
